import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ALL: "Alle",
      ORDER_MEALBOX: "Bestill matkasse",
      CATEGORIES: "kategorier",
      RECIPES: "Oppskrifter",
      RECIPE: "Oppskrift",
    },
    se: {
      ALL: "Alla",
      ORDER_MEALBOX: "Beställ matkasse",
      CATEGORIES: "kategorier",
      RECIPES: "Receptbank",
      RECIPE: "Recept",
    },
    dk: {
      ALL: "Alle",
      ORDER_MEALBOX: "Bestil måltidskasse",
      CATEGORIES: "kategorier",
      RECIPES: "Opskrifter",
      RECIPE: "Opskrift",
    },
  } as const
)[language];
